import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const emptyForm = {
  codigo: "",
  descricao: "",
  codigo_barras: "",
  unidades_por_caixa: "",
};

export function ProdutoCadastroDialog({ open, onOpenChange, produto, onSaved }) {
  const [form, setForm] = useState(emptyForm);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    setForm({
      codigo: produto?.codigo || "",
      descricao: produto?.nome || "",
      codigo_barras: produto?.ean || "",
      unidades_por_caixa: produto?.unidades_por_caixa ?? "",
    });
  }, [produto, open]);

  const atualizar = (campo, valor) => {
    setForm((anterior) => ({ ...anterior, [campo]: valor }));
  };

  const salvar = async (event) => {
    event.preventDefault();
    setSalvando(true);
    try {
      const { data } = await api.post("/produtos/cadastro", {
        ...form,
        unidades_por_caixa: Number(form.unidades_por_caixa),
      });
      toast.success(`Produto ${data.codigo} salvo`);
      onSaved?.(data);
      onOpenChange(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Não foi possível salvar o produto");
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="produto-cadastro-dialog" className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>{produto ? "Editar produto" : "Cadastrar produto"}</DialogTitle>
          <DialogDescription>
            Registre o código, a descrição, o EAN e o conteúdo de uma caixa fechada.
          </DialogDescription>
        </DialogHeader>
        <form className="space-y-4" onSubmit={salvar} data-testid="produto-cadastro-form">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <label className="space-y-1 text-sm font-semibold text-[#0F2A1F]">
              Código do produto
              <input
                required
                disabled={Boolean(produto)}
                value={form.codigo}
                data-testid="produto-cadastro-codigo-input"
                onChange={(event) => atualizar("codigo", event.target.value)}
                className="w-full rounded-md border border-[#D9E3DC] px-3 py-2 font-mono text-sm disabled:bg-[#F1F5F2]"
              />
            </label>
            <label className="space-y-1 text-sm font-semibold text-[#0F2A1F]">
              Unidades por caixa
              <input
                required
                min="1"
                type="number"
                value={form.unidades_por_caixa}
                data-testid="produto-cadastro-unidades-input"
                onChange={(event) => atualizar("unidades_por_caixa", event.target.value)}
                className="w-full rounded-md border border-[#D9E3DC] px-3 py-2 font-mono text-sm"
              />
            </label>
          </div>
          <label className="block space-y-1 text-sm font-semibold text-[#0F2A1F]">
            Descrição
            <input
              required
              value={form.descricao}
              data-testid="produto-cadastro-descricao-input"
              onChange={(event) => atualizar("descricao", event.target.value)}
              className="w-full rounded-md border border-[#D9E3DC] px-3 py-2 text-sm"
            />
          </label>
          <label className="block space-y-1 text-sm font-semibold text-[#0F2A1F]">
            Código de barras (EAN)
            <input
              required
              inputMode="numeric"
              value={form.codigo_barras}
              data-testid="produto-cadastro-ean-input"
              onChange={(event) => atualizar("codigo_barras", event.target.value)}
              className="w-full rounded-md border border-[#D9E3DC] px-3 py-2 font-mono text-sm"
            />
          </label>
          <button
            type="submit"
            disabled={salvando}
            data-testid="produto-cadastro-salvar-btn"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-[#0F6B3A] px-4 py-2.5 font-semibold text-white transition-colors hover:bg-[#0B5530] disabled:opacity-60"
          >
            {salvando ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
            Salvar cadastro
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}